export const thaylenBread = {
  id: "thaylenBread",
  link: "/#/recipes/recipes/thaylenBread",
  name: "Thaylen Bread",
  cuisine: "Thaylen",
  summary: "A rustic, whole wheat, free-form loaf.",
  inspiration: null,
  quantity: "1 loaf",
  time: "2 hours 40 minutes",
  notes:
    "This is a pretty standard whole wheat bread recipe. I didn't use any dairy, and used coconut oil instead of butter. Most wheat bread recipes use a blend of white flour and wheat flour, but I chose to use 100% wheat flour. This felt like a more rustic approach, and something that fit better with pre-industrial-revolution Roshar. I ground the flour myself from hard red wheat. I chose that wheat for the high protein (gluten) content, and freshly ground flour has better flavor due to the fresh oils. Finally, I decided to do a free-form loaf rather than use a tin, again for the old-time rustic feel.",
  quotes:
    "The bread had been purchased from a Thaylen bakery, which meant it was fluffy and brown. (The Way of Kings, ch. 33)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/thaylen-bread-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "wheatFlour",
          display:
            "3 3/4 to 4 1/4 cups whole wheat flour, divided, with additional as an optional topping"
        },
        {
          item: "yeast",
          display: "1 packet instant yeast"
        },
        {
          item: "water",
          display: "1 1/3 cups water"
        },
        {
          item: "honey",
          display: "2 tbsp honey"
        },
        {
          item: "coconut",
          display: "1/4 cup coconut oil"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        }
      ]
    }
  ],
  steps: [
    "Mix 1 1/2 cups flour and the yeast in an stand mixer's bowl. Set aside.",
    "In a saucepan, combine the water, honey, coconut oil, and salt. Heat over medium heat just until warm, about 110 degrees Fahrenheit.",
    "Add the liquid to the flour mixture. With the whisk attachment on your stand mixer, mix on low for 30 seconds, scraping the edges of the bowl occasionally with a wooden spoon to combine all the ingredients. Mix on high for 3 minutes.",
    "Replace the whisk attachment in the stand mixer with the dough hook attachment. Start adding the remaining flour, a bit at a time, mixing on low speed until the mixture forms a dough that holds together and pulls away from the sides of the bowl. You may not need the full amount of flour - add just enough to achieve the desired consistency.",
    "Mix on low for 5 minutes. Turn the speed of the mixer up to medium low and mix an additional 3 minutes. You should have a dough that is smooth and elastic.",
    "Remove the dough hook, form the dough into a ball, place back in the bowl, cover with a clean towel, and let rise in a warm place 1 hour or until doubled in size.",
    "Punch down the dough, then pat into a 4 inch by 8 inch rectangle. Roll up the rectangle, forming a 8 inch long roll. Tuck the ends down and pinch them to the bottom to seal them and form the loaf shape.",
    "Place the dough on a greased cookie sheet, cover with the towel, and let rise 30 minutes or until doubled in size.",
    "Preheat the oven to 350 degrees Fahrenheit. Score the top of the loaf, cutting lightly just into the surface in a few places. If desired, sprinkle the top of the loaf with a bit of extra flour, to match the look on Kabsal's bread in The Way of Kings. Bake for 35-40 minutes on the bottom rack. The bread will sound hollow when tapped when it is done.",
    "Remove from the oven, then slice and serve with jam."
  ]
}
